
import React, { useRef, useState } from "react";
import { Box, Grid2, Typography, useTheme, Skeleton } from "@mui/material";

import Highcharts, { solidgauge } from "highcharts";
import more from "highcharts/highcharts-more";
import HighchartsReact from "highcharts-react-official";
import { useGetSchedulePerformanceQuery } from "store/slices/apis/scheduleDashboarSlice";
import { useParams } from "react-router-dom";

if (typeof more === "function") {
    more(Highcharts);
}

const SchedulePerformanceIndicator = (props) => {
    const { id } = props;
    const theme = useTheme();
    const chartRef = useRef(null);
    const { data, isLoading } = useGetSchedulePerformanceQuery({ projectId: id });
    //const { data, isLoading } = useGetSchedulePerformanceQuery('9a0b277f-782d-45e0-beea-7e0c42c9b305');

    const speed = data?.schedulePerformanceIndex || 0;
    const clampedValue = Math.min(speed, 1);

    const chartOptions = {
        chart: {
            type: "gauge",
            plotBackgroundColor: null,
            plotBackgroundImage: null,
            plotBorderWidth: 0,
            plotShadow: false,
            height: "50%",
        },
        title: {
            text: "",
        },
        pane: {
            startAngle: -90,
            endAngle: 89.9,
            background: null,
            center: ["50%", "95%"],
            size: "180%",
        },
        yAxis: {
            min: 0,
            max: 1,
            tickPixelInterval: 72,
            tickPosition: "inside",
            tickColor: Highcharts.defaultOptions.chart.backgroundColor || "#FFFFFF",
            tickLength: 20,
            tickWidth: 0,
            minorTickInterval: null,
            labels: {
                enabled: false,
                // distance: 20,
                style: {
                    fontSize: "14px",
                },
            },
            lineWidth: 0,
            plotBands: [
                {
                    from: 0.0,
                    to: 0.19,
                    color: "#E44F3F",
                    thickness: 40,
                    borderRadius: '2px'
                },
                {
                    from: 0.2,
                    to: 0.39,
                    color: "#E96E61",
                    thickness: 40,
                    borderRadius: '2px'
                },
                {
                    from: 0.4,
                    to: 0.59,
                    color: "#FECE51",
                    thickness: 40,
                    borderRadius: '2px'
                },
                {
                    from: 0.6,
                    to: 0.79,
                    color: "#9ED3CC",
                    thickness: 40,
                    borderRadius: '2px'
                },
                {
                    from: 0.8,
                    to: 1,
                    color: "#49ABA0",
                    thickness: 40,
                    borderRadius: '2px'
                },
            ],
        },
        credits: {
            enabled: false,
        },
        series: [
            {
                name: "Schedule Performance Index",
                data: [clampedValue],
                tooltip: {
                    valueSuffix: "",
                },
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        return `<div>${speed.toFixed(2)}</div>`;
                    },
                    borderWidth: 0,
                    y: -60,
                    // x:20,
                    style: {
                        fontSize: "30px",
                        color:
                            (Highcharts.defaultOptions.title &&
                                Highcharts.defaultOptions.title.style &&
                                Highcharts.defaultOptions.title.style.color) ||
                            "#333333",
                    },
                },
                dial: {
                    radius: "80%",
                    backgroundColor: "gray",
                    baseWidth: 10,
                    baseLength: "0%",
                    rearLength: "0%",
                },
                pivot: {
                    backgroundColor: "gray",
                    radius: 6,
                },
            },
        ],
    };

    return (
        <Box sx={{ padding: 2, pb: 0, border: '1px solid #2525252E', borderRadius: '7px', minHeight: '230px', background: "#FFFFFF" }}>
            <Grid2 size={{ xs: 12, md: 12 }} sx={{ mb: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: "500", fontSize: '18px', color: `#182A4E`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
                    Schedule Performance Index
                </Typography>
                <Typography variant="caption" sx={{ fontWeight: "500", fontSize: '14px', color: `#182A4E80`, lineHeight: '100%', letterSpacing: '-0.4px' }}>
                    Indicating schedule efficiency to assess adherence to planned timelines
                </Typography>
            </Grid2>
            {isLoading ? (
                <Skeleton variant="rectangular" height={130} animation="wave" sx={{ borderRadius: 7 }} />
            ) : (
                <HighchartsReact highcharts={Highcharts} options={chartOptions} ref={chartRef} />
            )}
        </Box>
    );
};

export default SchedulePerformanceIndicator;
